import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bananas',
  templateUrl: './bananas.component.html',
  styleUrls: ['./bananas.component.css']
})
export class BananasComponent implements OnInit {
  videoId: string = "PBtM2vRD6PI";

  constructor() { }

  ngOnInit(): void {
  }

}
